'use strict';
jQuery(document).ready(function($) {

   const deviceAgent = navigator.userAgent.toLowerCase();
   const agentID = deviceAgent.match(/(iphone|ipod|ipad|android|webos|iemobile|opera mini|blackberry)/);

   if (agentID) {
      $('html').addClass('is-mobile');
   }

   $('[data-svg]').each(function(index, el) {
      const $img = $(el);
      const imgID = $img.attr('id');
      const imgClass = $img.attr('class');
      const imgURL = $img.data('svg');
      const imgWidth = $img.attr('width');

      $.get(imgURL, function(data) {
         // Get the SVG tag, ignore the rest
         let $svg = $(data).find('svg');

         // Add replaced image's ID to the new SVG
         if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
         }
         // Add replaced image's classes to the new SVG
         if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
         }

         if (typeof imgWidth !== 'undefined') {
            $svg = $svg.attr('width', imgWidth);
         }

         // Remove any invalid XML tags as per http://validator.w3.org
         $svg = $svg.removeAttr('xmlns:a');

         // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
         if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
            $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
         }

         // Replace image with new SVG
         $img.replaceWith($svg);

      }, 'xml');
   });


   $('body').on('click', '.jumper, .jumper-to > a', function(e) {
      e.preventDefault();
      const anchor = $(this).attr('href');
      $('html,body').animate({ scrollTop: $(anchor).offset().top }, 1000);
   });

   // // Header Fixo
   // $(window).on('scroll load', function(){
   //    const $header = $('.header');
   //    const $headerDummy = $('.header-dummy');
   //    const $offsetMenu = $('.offset-menu-top');
   //    const offsetMenuHeight = $header.height();
   //    const headerDummyHeight = $header.height();

   //    $headerDummy.height(headerDummyHeight);
   //    $offsetMenu.height(headerDummyHeight);
   // });

   // // Slide default
   // $('.slide-hero').each(function(index, el) {
   //    const prev = $(el).data('prev') ? $(el).data('prev') : '.swiper-button-prev';
   //    const next = $(el).data('next') ? $(el).data('next') : '.swiper-button-next';
   //    const pagination = $(el).data('pagination') ? $(el).data('pagination') : '.swiper-pagination';
      
   //    const slide = new Swiper(el, {
   //       effect: "fade",
   //       spaceBetween: 0,
   //       autoplay: {
   //          delay: 9000,
   //       },
   //       loop: true,
   //       speed: 1000,
   //       parallax: true,
   //       navigation: {
   //          nextEl: next,
   //          prevEl: prev,
   //       },
   //       pagination: {
   //          el: pagination,
   //          clickable: true,
   //       },
   //    });
   // });

   $('.swiper-photos').each(function(index, el) {      
      const prev = $(el).data('prev') ? $(el).data('prev') : '.swiper-button-prev';
      const next = $(el).data('next') ? $(el).data('next') : '.swiper-button-next';
      const pagination = $(el).data('pagination') ? $(el).data('pagination') : '.swiper-pagination';

      const slide = new Swiper(el, {
         slidesPerView: 1,
         spaceBetween: 0,
         autoplay: {
            delay: 8000,
         },
         // loop: true,
         speed: 1000,
         parallax: true,
         navigation: {
            nextEl: next,
            prevEl: prev,
         },
         pagination: {
            el: pagination,
            clickable: true,
         },
      });
   });

   $('.swiper-gallery').each(function(index, el) {      
      const prev = $(el).data('prev') ? $(el).data('prev') : '.swiper-button-prev';
      const next = $(el).data('next') ? $(el).data('next') : '.swiper-button-next';
      const pagination = $(el).data('pagination') ? $(el).data('pagination') : '.swiper-pagination';

      const slide = new Swiper(el, {
         slidesPerView: 1,
         spaceBetween: 30,
         autoplay: {
            delay: 8000,
         },
         // loop: true,
         speed: 1000,
         parallax: true,
         navigation: {
            nextEl: next,
            prevEl: prev,
         },
         pagination: {
            el: pagination,
            clickable: true,
         },
      });
   });

   // $('.swiper-carousel').each(function(index, el) {      
   //    const prev = $(el).data('prev') ? $(el).data('prev') : '.swiper-button-prev';
   //    const next = $(el).data('next') ? $(el).data('next') : '.swiper-button-next';
   //    const pagination = $(el).data('pagination') ? $(el).data('pagination') : '.swiper-pagination';

   //    const slide = new Swiper(el, {
   //       spaceBetween: 20,
   //       autoplay: {
   //          delay: 8000,
   //       },
   //       // loop: true,
   //       speed: 1000,
   //       parallax: true,
   //       navigation: {
   //          nextEl: next,
   //          prevEl: prev,
   //       },
   //       pagination: {
   //          el: pagination,
   //          clickable: true,
   //       },
   //       breakpoints: {
   //          // when window width is >= 480px
   //          576: {
   //            slidesPerView: 1,
   //            slidesPerGroup: 1,
   //          },
   //          // when window width is >= 768px
   //          768: {
   //             slidesPerView: 2,
   //             slidesPerGroup: 2,
   //          },
   //          // when window width is >= 1024px
   //          1024: {
   //             slidesPerView: 3,
   //             slidesPerGroup: 3,
   //          },
   //          // when window width is >= 1200px
   //          // 1200: {
   //          //    slidesPerView: 4,
   //          //    slidesPerGroup: 4,
   //          // }
   //       }
   //    });
   // });

   // // Validação de formulário
   // $('.form-contato').validate({
   //    errorPlacement: function(error, element) {
   //       return false;
   //    },
   //    rules: {
   //       nome: {
   //          required: true,
   //          minlength: 2
   //       },
   //       email: {
   //          required: true,
   //          email: true,
   //       },
   //       telefone: {
   //          required: true,
   //          minlength: 2
   //       },
   //    },
   //    submitHandler: function(form) {
   //       // const formData = $(form).serialize();
   //    }
   // });

   /* JQUERY MASK */
   if(jQuery().mask){
      // Formatando campos com mascaras
      const SPMaskBehavior = function(val) {
         return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
      },
      spOptions = {
         onKeyPress: function(val, e, field, options) {
            field.mask(SPMaskBehavior.apply({}, arguments), options);
         }
      },
      optionsCpfCnpj = {onKeyPress: function(documento, e, field, optionsCpfCnpj){
         var masks = ['000.000.000-009', '00.000.000/0000-00'];
         var mask = (documento.length>14) ? masks[1] : masks[0];
         $('.mask-document').mask(mask, optionsCpfCnpj);
      }};

      $('.mask-phone').mask(SPMaskBehavior, spOptions);
      $('.mask-date').mask('99/99/9999');
      $('.mask-cep').mask('00000-000');
      $('.mask-cpf').mask('000.000.000-00');
      $('.mask-cnpj').mask('00.000.000/0000-00');
      $('.mask-number').mask('0#');
      $('.mask-creditcard').mask('9999 9999 9999 9999');
      $('.mask-document').mask('000.000.000-00',optionsCpfCnpj);
   }
   
   $('.open-nav-locations').on('click', function(event){
      event.preventDefault();
      $('.nav-locations').stop().slideToggle();
   });

   $('.open-header-nav').on('click', function(event){
      event.preventDefault();
      $('.header-nav').stop().slideToggle();
   });

   // // LightBox
   // $(".open-fancybox").fancybox({
   //    // 'titleShow'     : false
   // });

   SmoothScroll({
      animationTime: 600,
      stepSize: 50,
      // accelerationDelta: 100,
   });

   // let wow = new WOW({
   //    boxClass: 'wow',
   //    animateClass: 'animated',
   //    offset: 40,
   //    mobile: true,
   //    live: true
   // });

   // wow.init();
});
